import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from "../assets/css/aboutUs.module.css"; // import Layout from "../../components/Layout";

import Layout from "../components/sidebarPro";
import Head from "next/head";
import Header from "../components/aboutUs/header";
import Section1 from "../components/aboutUs/section1";
import OurTeam from "../components/aboutUs/OurTeam";
import Footer from "../components/footer/Footer";

var AboutUs = function AboutUs() {
  return /*#__PURE__*/_jsxs(Layout, {
    page: "about us",
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "about wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx(Section1, {}), /*#__PURE__*/_jsx(OurTeam, {}), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export var __N_SSG = true;
export default AboutUs;